import { Component, Input, OnInit } from '@angular/core';
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    Validators,
} from '@angular/forms';
import { SupportService } from 'app/services/public/support.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
    public sent = false;
    allServices = [
        {
            id: 'realestate',
            i18nKey: 'contact-us-form-service-realestate',
        },
        {
            id: 'selfstorage',
            i18nKey: 'contact-us-form-service-selfstorage',
        },
        {
            id: 'other',
            i18nKey: 'contact-us-form-service-other',
        },
    ];
    _form: UntypedFormGroup;
    private sendSubject = new Subject<void>();
    constructor(
        private _formBuilder: UntypedFormBuilder,
        private supportService: SupportService,
    ) {}

    ngOnInit(): void {
        this._form = this._formBuilder.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            service: ['', Validators.required],
            request: ['', [Validators.required, Validators.maxLength(4000)]],
            // Honeypot: bleibt bei Menschen leer, Bots füllen es aus – dann wird nichts gesendet
            website: [''],
        });

        this.sendSubject.pipe(
            debounceTime(300), // Adjust the debounce time as needed
        ).subscribe(() => {
            this.executeSend();
        });
    }

    send() {
        this.sendSubject.next();
    }

    private executeSend() {
        const form = this._form.getRawValue();
        if (form.website) {
            // Spam-Verdacht: so tun, als wäre gesendet worden
            this._form.reset();
            this.sent = true;
            return;
        }
        this.supportService.sendRequestForm(form).subscribe(() => {
            this._form.reset();
            this.sent = true;
        });
    }
}
